<mat-label class="subHeading">Annuity Type<span *ngIf="isRequired" class="star">*</span></mat-label>
<mat-select formControlName="annuity_type" class="coverage" placeholder="Select">
    <mat-option value="immediate">Immediate</mat-option>
    <mat-option value="deferred">Deferred</mat-option>
</mat-select>